(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["same-day-stock"] && !Shopify.designMode) return;
  try {
    (() => {
  const blocks = document.querySelectorAll('[data-masa-countdown]');

  if (!blocks.length) return;

  blocks.forEach((el) => {
    if (el.dataset.go === '1') return;

    el.dataset.go = '1';

    const timezone = el.dataset.timezone || 'America/Los_Angeles';

    function getTimeInTimezone() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).formatToParts(new Date());

      const values = {};

      parts.forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });

      return new Date(
        Number(values.year),
        Number(values.month) - 1,
        Number(values.day),
        Number(values.hour),
        Number(values.minute),
        Number(values.second)
      );
    }

    function tick() {
      const now = getTimeInTimezone();

      const next = new Date(now);
      next.setDate(next.getDate() + 1);
      next.setHours(0, 0, 0, 0);

      const difference = Math.max(0, next.getTime() - now.getTime());

      const hours = Math.floor(difference / 3600000);
      const minutes = Math.floor((difference % 3600000) / 60000);
      const seconds = Math.floor((difference % 60000) / 1000);

      el.textContent =
        String(hours).padStart(2, '0') +
        ':' +
        String(minutes).padStart(2, '0') +
        ':' +
        String(seconds).padStart(2, '0');
    }

    tick();

    const interval = setInterval(() => {
      if (!document.body.contains(el)) {
        clearInterval(interval);
        return;
      }

      tick();
    }, 1000);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
